// このファイルを消してからmake driversすると生成し直しますが、ファイルがあれば上書きはされません。

import {
  getDriver,
  initSingleTable as initSingleTableForMultiOrgCaseDataManagement,
  tableClear as tableClearForMultiOrgCaseDataManagement,
} from '@/appLogic/stacks/multiOrganizationCaseDataManagement';
import {
  initSingleTable as initSingleTableForPreferenceManagement,
  tableClear as tableClearForPreferenceManagement,
} from '@/appLogic/stacks/preferenceManagement';
import {
  getAllJournalData,
  initSingleTable as initSingleTableForJournal,
} from '@projectRoot/appLogic/applicationManage/dbAccess/journal';

const params: any = process.env.APP_PARAMS;

const tableNames: {[type:string]: string} = {};
export const getTableNameForStack = (stackName: string) => tableNames[stackName];


// export const tableInit = async () => {
//   const useDummyDriver = true;
//
//   await initSingleTableForMultiOrgCaseDataManagement(`matchboostCaseData${params.env}`, useDummyDriver);
//   await initSingleTableForPreferenceManagement(`matchboostPreference${params.env}`, useDummyDriver);
//   await initSingleTableForJournal(`journalTbl${params.salt}`);
// };
export const tableInit = async () => {
  const useDummyDriver = false;

  await initSingleTableForMultiOrgCaseDataManagement(`matchboostCaseData${params.env}`, useDummyDriver);
  await initSingleTableForPreferenceManagement(`matchboostPreference${params.env}`, useDummyDriver);
  await initSingleTableForJournal(`journalTbl${params.salt}`);
  if (useDummyDriver) {
    getDriver(`matchboostCaseData${params.env}`).setOrganizationId('Mde000c4487fe');  // ダミードライバのほうも変更が必要
  }
};

export const flushTables = async () => {
  await tableClearForMultiOrgCaseDataManagement();
  await tableClearForPreferenceManagement();
};
